import { Injectable } from "@angular/core";
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { IMemebersViewModel, IMemebersInputModel, IEipUserModel, IProjectMembersInputModel, IProjectMemberViewModel, IMemeberloginInputModel, IMemeberloginViewModel } from 'src/app/ViewModel/MembersModel';

export enum Criteria {
    at_least_eight_chars,
    at_least_one_lower_case_char,
    at_least_one_upper_case_char,
    at_least_one_digit_char,
    at_least_one_special_char,
}

@Injectable({
    providedIn: 'root'
})
export class ExternalMemberService {

    private getMemberDetailsListUrl = 'Member/GetMembersList';
    private insertUpdateMemberDetailsUrl = 'Member/InsertUpdateMemberDetails';
    private eipUserDetailsUrl = 'Member/GetEipUserDetails';
    private userUnlockUrl = 'Member/UnlockUserDetails';
    private getMembersListAgainstProject= 'Member/GetMembersListAgainstProject';
    private userWebLogin ='Member/GetEipWebLoginDetails';

    constructor(private restAPTService: RestApiService) { }


    /**
     * Get Members List API
     * @param member_Id 50
     * @param company_Code 50
     */
    public GetMembersList(member: IMemebersInputModel): Observable<IMemebersViewModel[]> {
        return this.restAPTService.new_POST(this.getMemberDetailsListUrl, member);
    }

    public GetMembersListAgainstProject(member: IProjectMembersInputModel): Observable<IProjectMemberViewModel[]>
    {
        return this.restAPTService.new_POST(this.getMembersListAgainstProject,member)
    }

    /**
     * Insert and Update Member Details
     * @param memberDetails 
     */
    public InsertUpdateMemberDetails(memberDetails: IMemebersViewModel): Observable<any> {

        return this.restAPTService.new_POST(this.insertUpdateMemberDetailsUrl, memberDetails);
    }

    public GetEipUserDetails(eipUserDetails: IEipUserModel): Observable<any> {
        return this.restAPTService.new_POST(this.eipUserDetailsUrl, eipUserDetails)
    }

    public getCriteriaMap(criteriaMap: Map<Criteria, RegExp>) {
        criteriaMap.set(Criteria.at_least_eight_chars, RegExp(/^.{8,25}$/));
        criteriaMap.set(Criteria.at_least_one_lower_case_char, RegExp(/^(?=.*?[a-z])/));
        criteriaMap.set(Criteria.at_least_one_upper_case_char, RegExp(/^(?=.*?[A-Z])/));
        criteriaMap.set(Criteria.at_least_one_digit_char, RegExp(/^(?=.*?[0-9])/));
        criteriaMap.set(Criteria.at_least_one_special_char, RegExp(/^(?=.*?[" !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"])/));
    }

    public containAtLeastEightChars(val: string): boolean {
        return val.length >= 8;
    }

    public containsMixedChars(val: string, criteriaMap: Map<Criteria, RegExp>): boolean {
      let x:any =criteriaMap.get(Criteria.at_least_one_lower_case_char);
      let y:any =criteriaMap.get(Criteria.at_least_one_upper_case_char)
      let z:any =criteriaMap.get(Criteria.at_least_one_digit_char)
        return x.test(val) &&y.test(val) &&z.test(val);
    }

    public containAtLeastOneSpecialChar(val: string, criteriaMap: Map<Criteria, RegExp>): boolean {
        
        let x:any = criteriaMap
        .get(Criteria.at_least_one_special_char);
        return  x?x.test(val):false;
    }
    public UnlockUserDetails(member_Id: any): Observable<any> {
        let _objmember = {
            memberId: member_Id
        }
        return this.restAPTService.new_POST(this.userUnlockUrl, _objmember)
    }
    public GetwebLoginList(member: IMemeberloginInputModel): Observable<IMemeberloginViewModel[]> {
        return this.restAPTService.new_POST(this.userWebLogin, member);
    }

}